import React, { useState } from 'react';
import './Signin.css';
import { FaEnvelope } from "react-icons/fa";
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!emailRegex.test(email)) {
    alert('Please enter a valid email address');
    return;
  }
    alert(`Password reset link sent to: ${email}`);
    // You can integrate actual API call here
  };

  return (
    <div className="sign-in-container fade-in">
        <Link to="/" className="back-link">← Back to Sign In</Link>

      <h1>Forgot Password</h1>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <FaEnvelope className="icon" />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="sign-in-btn">Send Reset Link</button>
        </form>
        

      </div>
    </div>
  );
};

export default ForgotPassword;
